import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { first, take } from 'rxjs/operators';
import { ReviewService, Review } from '@app/_components/review';
import { AlertService, AuthenticationService, DataCacheService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService } from 'primeng/api';
import { Locations, ListingStatus } from '@app/_helpers/constants';
import { DialogService } from 'primeng/dynamicdialog';
import { Feature, FeatureService } from '..';
import { FeatureComponent } from '../feature/feature.component';


@Component({
    selector: 'app-feature-list-all',
    templateUrl: './feature-list.component.html',
    styleUrls: ['./feature-list.component.css'],
    providers: [DialogService],
    standalone: false
})
export class FeatureListAllComponent implements OnInit, OnChanges {

	datasource: Feature[];

	@Input() shortTermRentalId: number;
	@Input() developmentId: number;
	@Input() describesType: string;
	@Input() featureType: string;
	@Input() featuresList: Feature[] = [];
	@Input() title: string;

	feature: Feature;
	features: Feature[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	formLoading = false;
	userStatusOptions: SelectItem[];

	statuses = [
		{ name: 'Draft', value: 1 },
		{ name: 'New', value: 2 },
		{ name: 'Approved', value: 3 },
		{ name: 'Rejected', value: 4 },
	];



	constructor(
		private authenticationService: AuthenticationService,
		private featureService: FeatureService,
		private dataCacheService: DataCacheService,
		private alertService: AlertService,
		private messageService: MessageService,
		private router: Router,
		public dialogService: DialogService
	) { }



	ngOnInit() {
		console.log('describesType' + this.describesType);
		console.log('featuresList' + this.featuresList.length);
		// if we have a featureType type with multiple describeTypes (ie bedrooms)
		if (this.describesType && this.describesType.length > 0 && this.shortTermRentalId) {
			this.findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType();
		}
		else if (this.describesType && this.describesType.length > 0 && this.developmentId) {
			this.findAvailablePropertyFeaturesByDevelopmentIdAndDescribesTypeAndFeatureType();
		}

		// filter the featureType
		this.filterFeatureType(); 
	}


	findAvailablePropertyFeaturesByShortTermRentalId(shortTermRentalId: number) {
		try {
			this.formLoading = true;

			this.featureService.findAvailablePropertyFeaturesByShortTermRentalId(shortTermRentalId).pipe(take(1))
				.subscribe(
					res => {
						console.log('findAvailablePropertyFeaturesByShortTermRentalId' + this.shortTermRentalId);
						this.featuresList = res.data.propertyFeatures;
						this.features = this.featuresList;
						// console.log(JSON.stringify(this.featuresList));
						// this.alertService.success(res, true);
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onEditComplete(event) {
		console.log("SAVING!" + JSON.stringify(event.data))
		this.formUpdate(event.data);
	}
	
		ngOnChanges() {
		// This is called when the parent property. When the parent first initializes, it has not got the features yet.  This updates the list when the features are ready.
		this.features = this.featuresList;
		this.filterFeatureType();
	}

	filterFeatureType() {
		// to filter a list https://stackoverflow.com/questions/34901593/how-to-filter-an-array-from-all-elements-of-another-array
		this.features = this.featuresList.filter(feature => feature.featureType === this.featureType);
	}

	onStatusChange(event, feature) {
		let isChecked = event.checked;
		// console.log('onStatuChange', event);
		if (event.checked) {
			// if an existing propertyFeature, update status to 1 and keep all the existing data
			if (feature.propertyFeatureId) {
				console.log('onStatuChange', 'CHECKED!');
				console.log('onStatuChange', feature);
				feature.status = true;
				this.formUpdateStatus(feature);
			}
			else {
				// create a new one with just the basic info.  More editing can be done once enabled.
				let newFeature: any = {};
				newFeature.status = true;
				newFeature.featureId = feature.featureId;
				newFeature.describesType = this.describesType;
				newFeature.shortTermRentalId = this.shortTermRentalId;
				newFeature.developmentId = this.developmentId;
				this.formAddFeature(newFeature);
			}
		}
		else {
			console.log('onStatuChange', 'UNCHECKED!');
			// if an existing propertyFeature, update status to 0
			if (feature.propertyFeatureId) {
				feature.status = false;
				this.formUpdateStatus(feature);
			}
			else {
				// do nothing.  Not sure how we would get here.
			}
		}
	}

	formUpdateStatus(featureObject: any) {
		try {
			// stop here if form is invalid
			// console.log('Feature Submitted: ' + JSON.stringify(featureObject));

			// this.formLoading = true;
			this.featureService.updateStatus(featureObject)
				.subscribe(
					res => {
						console.log('Feature-Update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formAddFeature(feature: any) {
		try {
			// console.log('Form Add Submitted: ' + JSON.stringify(feature));
			// this.formLoading = true;

			// use the .pipe(take(1)) to prevent double firing...
			this.featureService.add(feature).pipe(take(1))
				.subscribe(
					res => {
						// console.log('Feature-Add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);

						this.features.map((featureEntry, i) => {

							// console.log('if ' + featureEntry.featureId + '==' + res.data.propertyFeature.featureId + ' && ' + this.describesType + '==' + res.data.propertyFeature.describesTyp);

							if (featureEntry.featureId == res.data.propertyFeature.featureId && this.describesType == res.data.propertyFeature.describesType) {
								console.log('MATCH');
								this.features[i].propertyFeatureId = res.data.propertyFeature.propertyFeatureId;
							}
						});
					},
					err => {
						// console.log('Feature-Add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate(feature) {
		try {
			// Guard: feature must have a propertyFeatureId before updating.
			// This can be null when a feature was just toggled on but the add-callback
			// hasn't returned yet (race condition). Silently skip — the user can re-edit.
			if (!feature.propertyFeatureId) {
				return;
			}

			// this.formLoading = true;

			this.featureService.update(feature)
				.subscribe(
					res => {
						// console.log('Feature-Update SUCCESS: ' + JSON.stringify(res));

						// update the list
						this.features.map((featureEntry, i) => {
							if (featureEntry.featureId == res.data.propertyFeature.featureId && featureEntry.describesType == res.data.propertyFeature.describesType) {
								this.features[i].propertyFeatureId = res.data.propertyFeature.propertyFeatureId;
							}
						});
						this.alertService.success(res, true);
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	
	findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType() {
		try {
			this.formLoading = true;
			this.featureService.findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType(this.shortTermRentalId, this.describesType, this.featureType).pipe(take(1))
				.subscribe(
					res => {
						// // console.log('findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType Id#' + this.shortTermRentalId + ' ' + this.describesType);
						this.featuresList = res.data.propertyFeatures;
						this.features = this.featuresList;
						this.filterFeatureType();
						// this.alertService.success(res, true);
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	findAvailablePropertyFeaturesByDevelopmentIdAndDescribesTypeAndFeatureType() {
		try {
			this.formLoading = true;

			// BUGFIX: 9-23-2020 this was miscoded to findAvailablePropertyFeaturesByShortTermRentalIdAndDescribesTypeAndFeatureType so it was returning str options instead of dev options
			this.featureService.findAvailablePropertyFeaturesByDevelopmentIdAndDescribesTypeAndFeatureType(this.developmentId, this.describesType, this.featureType).pipe(take(1))
				.subscribe(
					res => {
						// // console.log('findAvailablePropertyFeaturesByDevelopmentIdAndDescribesTypeAndFeatureType' + this.developmentId + ' ' + this.describesType);
						this.featuresList = res.data.propertyFeatures;
						this.features = this.featuresList;
						this.filterFeatureType();
						// this.alertService.success(res, true);
					},
					err => {
						// console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			// console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	// capitalize and space the featueType 
	trimFeatureType(featureType: any) {
		if (featureType) {

			// make first letter uppercase
			featureType = featureType.charAt(0).toUpperCase() + featureType.slice(1);

			// put a space before each uppercase (camel) letter
			featureType = featureType.replace(/([A-Z])/g, ' $1').trim();

			return featureType;
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}